<template>
  <div>
    <div id="recaptcha-error">
      <b-modal
        v-model="show"
        hide-header
        no-close-on-esc
        ok-only
        static
        @ok="modalClosed"
      >
        <component :is="recaptchaErrorActual" />
      </b-modal>
    </div>
  </div>
</template>

<script>
import recaptchaVerifyContent from './content/recaptcha-verify.vue'

export default {
  name: 'square-payment-recaptcha-verify-wrapper',
  props: {
    recaptchaError: {
      type: Object,
      requried: false,
      default: () => null
    }
  },
  computed: {
    show: function() {
      return true
    },
    recaptchaErrorActual: function() {
      return this.recaptchaError ? this.recaptchaError : recaptchaVerifyContent
    }
  },
  methods: {
    modalClosed: function() {
      this.$emit('closed')
    }
  }
}
</script>

<style>

</style>
